<template>
    <div class="user-help">
        <v-card-title>{{$t('HelpUser.standart_user_path')}}</v-card-title>
        <v-card-subtitle>1. {{$t('HelpUser.create_call')}} </v-card-subtitle>
        <v-card-subtitle>
            {{$t('HelpUser.create_request_button')}} <br>
            {{$t('HelpUser.follow_instructions_application')}}
        </v-card-subtitle>
        <v-img
        max-width="600"
        src="../../../assets/help-user/Screenshot_4.png"></v-img>
        <v-card-subtitle>2. {{$t('HelpUser.current_status_requests')}} </v-card-subtitle>
        <v-img
        max-width="600"
        src="../../../assets/help-user/Screenshot_5.png"></v-img>
        <v-card-subtitle>
            3. {{$t('HelpUser.application_name_page')}}
        </v-card-subtitle>
        <v-img
        max-width="600"
        src="../../../assets/help-user/Screenshot_1.png"></v-img>
        <v-card-title>{{$t('HelpUser.viewing_pdf')}}</v-card-title>
        <v-card-subtitle>
            4. {{$t('HelpUser.view_picture_below')}}
        </v-card-subtitle>
        <v-img
        max-width="600"
        src="../../../assets/help-user/Screenshot_2.png"></v-img>
        <v-card-title>{{$t('HelpUser.editing')}}</v-card-title>
        <v-card-subtitle>
            5. {{$t('HelpUser.edit_pencil_created')}}
        </v-card-subtitle>
        <v-img
        max-width="600"
        src="../../../assets/help-user/Screenshot_3.png"></v-img>
        <v-card-title>{{$t('HelpUser.deleted')}}</v-card-title>
        <v-card-subtitle>
            6. {{$t('HelpUser.delete_basket_icon')}}
        </v-card-subtitle>
        <v-img
        max-width="600"
        src="../../../assets/help-user/Screenshot_6.png"></v-img>
        <br>
        <hr>
        
        <v-card-title>{{$t('HelpUser.help')}}</v-card-title>
        <v-card-subtitle>
            {{$t('HelpUser.questions_working_corner')}}
        </v-card-subtitle>
        <v-img
        max-width="600"
        src="../../../assets/help-user/Screenshot_7.png"></v-img>
    </div>
</template>
<script>
export default {
    name: 'UserHelp'
}
</script>